import React, { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import { fetchAPI } from "../service/Encrtyption";
import { useNavigate } from "react-router-dom";
import Layout from "../layout";
import LoginBannerhi from "../../assets/images/HindiBanner.png";
import LoginBannermr from "../../assets/images/MarathiBanner.png";
import GenuityCheck from "../../assets/images/Bottle.png";
import Right from "../../assets/images/right.png";
 import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { genuityCheckData, login, spinStatus, spinData } from "./redux/store.js";
import { Loader } from "../loader/index.js";
import { Snackbar } from "@mui/material";
import CustomSnackbar from "../snackbar/index.js";
import { useTranslation } from "react-i18next";
import CustomModal from "../../components/modal";
import CustomRoulette from "../../components/WheelComponent";
import { parseScanData } from "../../utils/parseScanData";
import { Button } from "react-bootstrap";
import SuccessIcon from "../../../src/assets/images/successIcon.png";
import Bottle from "../../../src/assets/images/Bottle.png";
import Close from "../../assets/images/close.png";
import notGeniuneImg from "../../assets/images/notgenuine.png";
import OtpInput from "react-otp-input";
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import { setOtpVerified } from "../../utils/otpSession";

export const OTPverification = () => {
  const { t, i18n } = useTranslation();
   const { lang } = useParams();
  const currentLanguage = lang;
  const dispatch = useDispatch();
  const [errroMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [scanedDataObject, setScanedDataObject] = useState(false);
  const [scanResponseData, setScanResponseData] = useState({});
  const [scanErrorResponseData, setscanErrorResponseData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [spinModalShow, setSpinModalShow] = useState(false);
  const [stopPrizeNumber, setStopPrizeNumber] = useState("2");
  const [disableBtn, setDisableBtn] = useState(false);
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [ErrorModalGenunity, setErrorModalGenunity] = useState(false);
  const [retailerMblNbr, setRetailerMblNbr] = useState('');
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [showRetailerInput, setShowRetailerInput] = useState(false);
  const [showCropInput, setShowCropInput] = useState(false);
  const [isMandetoryReatilerMobileNumber, setIsMandetoryReatilerMobileNumber] = useState(false);
  const [isMandetoryCropMaster, setIsMandetoryCropMaster] = useState(false);
  const [selectedCropId, setSelectedCropId] = useState('');
  const [selectedCropName, setSelectedCropName] = useState('');


  const [cropList, setCropList] = useState([]);
 
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [otpDigits, setOtpDigits] = useState(""); // State for OTP digits
  const genunityData = useSelector((state) => state?.genunityData);
  const user = useSelector((state) => state?.user);
  const scanedData = useSelector((state) => state?.scandataUrl);
  const isAuthenticated = useSelector((state) => state.isAuthenticated);

  const mobileNumber = user?.mobileNumber;
  const customerId = user?.customerId;

  useEffect(() => {
    const result = parseScanData(scanedData);
    if (result) {
      setScanedDataObject(result);
    }
  }, [scanedData]);

  const [formData, setFormData] = useState({
    deviceType: "WEB",
    mobileNumber: "",
    otp: "",
    destinationURL: "/customer/saveGenuinityCheckDetails_V2_acviss",
    deviceId: "",
    otpVerified: false,
    countryId: 5,
    directScanConsentAgreed : true
  });

  const [resendOtp, setResendOtp] = useState({
    versionCode: 1,
    destinationURL: "/customer/resendOTP",
    deviceId: "",
    countryId: 5,
  });

  const navigate = useNavigate();
  const inputRefs = useRef(
    Array(6)
      .fill(null)
      .map(() => React.createRef())
  );

  const handleInputChange = (otpDigits) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...scanedDataObject,
      otp: otpDigits,
      mobileNumber: mobileNumber,
      customerId: customerId,
    }));

    setOtpDigits(otpDigits);
  };

  const [OTP, setOTP] = useState("");
  function handleChange(OTP) {
    setOTP(OTP);
  }

  const onSubmit = async () => {


    setLoading(true);

    ReactGA.event({
      category: 'User Verify OTP',
      action: 'CLK_VERIFY_OTP_BTN'
    });

    try {
      //debugger;

      const { otp } = formData; // Assuming 'otp' is the key for the OTP value
      const trimmedOtp = otp.trim();
      if (!otp || otp.trim() === "" || trimmedOtp.length !== 6) {
        // Check if OTP is empty or only whitespace
        setErrorMsg(t("otpError")); // Set an error message for empty OTP
        setLoading(false);
        return;
      }

      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL_SCAN,
        formData,
        {
          customerid: user?.customerId,
          mobileNumber: user?.mobileNumber,
          userAuthorizationToken: "",
          deviceid: "WEB", 
          appLangCode:currentLanguage 
        }
      );
      const jsonReposneData = JSON.parse(responseData);
     // console.log(jsonReposneData, "otp response data");

      setShowRetailerInput(jsonReposneData?.isShowReatilerMobileNumber);
      setIsMandetoryReatilerMobileNumber(jsonReposneData?.isMandetoryReatilerMobileNumber);
      setShowCropInput(jsonReposneData?.isShowCropMaster);
      setIsMandetoryCropMaster(jsonReposneData?.isMandetoryCropMaster);

      const croplist = jsonReposneData.cropMasterList || [];
      setCropList(croplist);

      if (
        jsonReposneData?.statusCode === "200" &&
        jsonReposneData?.uq_responseCode === "100"
      ) {
        setScanResponseData(jsonReposneData);
        setOtpVerified(true);
        dispatch(genuityCheckData(jsonReposneData));
        setModalShow(true);
      } else if (
        jsonReposneData?.statusCode === "200" &&
        jsonReposneData?.uq_responseCode != "100"
      ) {
        //debugger;
        setLoading(false);
        setscanErrorResponseData(jsonReposneData);
        setErrorModalGenunity(true);
      } else {
        if (
          jsonReposneData?.message === "OTP Invalid." ||
          jsonReposneData?.message === "OTP Expired."
        ) {
          setDisableBtn(true);
          setErrorMsg(jsonReposneData?.message);
          setOtpDigits("");
          setOtpVerified(false);
        } else {
          setOtpVerified(false);
          setErrorMsg(jsonReposneData?.message || t("invalid_OTP"));
        }
      }
    } catch (error) {
      //  debugger;
      setErrorMsg("Please scan the QR code to proceed");
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    // debugger;
    setSpinModalShow(false);
    setRewardUpdateModal(true);
  };

  // retailer mbl input
  const handleMblInput = (event) => {
    const { value } = event.target;
    const inputValue = value;
    const numericValue = inputValue.replace(/\D/g, "");
    const limitedValue = numericValue.slice(0, 10);
    const validValue = /^[6-9]\d{0,9}$/.test(limitedValue) ? limitedValue : "";
    event.target.value = validValue;
    setRetailerMblNbr(validValue); 
  };

  const cropChange = (event) => {
    const selectedId = event.target.value;
    const selectedCrop = cropList.find(crop => crop.id === parseInt(selectedId));
    if (selectedCrop) {
      setSelectedCropId(selectedCrop.id);
      setSelectedCropName(selectedCrop.name); 
    }
  }; 
 
  const handleSpin = () => {
    // debugger;
    if (retailerMblNbr.length > 0 && retailerMblNbr.length < 10) {
      // setMobileNumberError(t("mobileErrorMsg")); 
      alert("please enter a valid mobile number");
    }
    else if (isMandetoryReatilerMobileNumber && retailerMblNbr.length === 0) {
      alert("please enter mobile number");
    }
    else if (isMandetoryCropMaster && selectedCropName === "") {
      alert("please Select Crop");
    }
    else {
      // setMobileNumberError("");
      dispatch(spinStatus(true));
     }
  };


  const openSpinWheel = () => {
    ReactGA.event({
      category: 'User Open Spin Wheel',
      action: 'CLK_OPEN_SPINWHEEL_BTN'
    });

    // debugger;
    setModalShow(false);
    setSpinModalShow(true);
  };

  
  const handleResendOtp = async () => {

    setLoading(true);

    ReactGA.event({
      category: 'User Resend OTP',
      action: 'CLK_RESEND_OTP_BTN'
    });

    const updatedData = {
      ...resendOtp,
      customerId: user?.customerId,
      mobileNumber: user?.mobileNumber, 
    };
   // console.log(updatedData+"niharika");
    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        updatedData
      );
      const jsonReposneData = JSON?.parse(responseData);
      setErrorMsg(jsonReposneData?.message);
    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };
  const renderInput = (inputProps, index) => (
    <>
      <input 
        {...inputProps}
        type="tel"
        style={{ width: "40px", margin: "4px", height: "40px" }} 
      />
    </>
  );

  const hide = () => {
    setErrorMsg(""); // Assuming you have a state to manage the error message
  };

  const handleKeyDown = (e) => {
    // Allow only numeric key codes (0-9) and specific control keys (e.g., Backspace, Delete)
    const allowedKeyCodes = [8, 9, 46]; // Backspace (8), Tab (9), Delete (46)

    if (!allowedKeyCodes.includes(e.keyCode)) {
      // Prevent default for non-allowed key codes (e.g., letters, symbols)
      if (e.keyCode < 48 || e.keyCode > 57) {
        e.preventDefault();
      }
    }
  };

  const handleNavigation = () => {
    //debugger; 
    if (user) {
      navigate(`/${lang}/home`);
    } else {
      const currentPath = `/login`;
      navigate(`/${lang}${currentPath}}`);
    }
  };


  //change baneer based on the lang

  let bannerImageSrc;
  if (lang === 'hi') {
    bannerImageSrc = LoginBannerhi;
  } else if (lang === 'mr') {
    bannerImageSrc = LoginBannermr;
  } else {
    bannerImageSrc = LoginBannerhi;
  }



  return (
    <>
      <Layout>
        <div className="main">
          <div className="container p-0">
            {loading && <Loader />}
            <div className="card border-0">
              <img
                src={bannerImageSrc}
                className="img-fluid w-100"
                alt="banner"
              />
              <div className="mt-3 text-center submitInfoText">
                <p className="mb-2">
                  {t("otpText").replace("{mobileNumber}", mobileNumber)}
                </p>
              </div>

              <div className="card-body px-2 pt-0 pb-2">
                <div className="px-4 py-2">
                  <form
                    action=""
                    method="post"
                    id="strongarmLogin-form"
                    className=""
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="form-group" id="opt_input">
                      {/* <label htmlFor="number" className="mt-0">
                        {t("OTPLabel")}
                      </label> */}
                      <div className="otp-input-fields mb-1">
                        {/* {otpDigits.map((digit, index) => (
                          <input
                            key={index}
                            type="number"
                            className="otp__digit shadow"
                            name="digit[]"
                            maxLength="1"
                            value={digit}
                            autoComplete="off"
                            ref={inputRefs.current[index]}
                            onChange={(e) =>
                              handleInputChange(index, e.target.value, e)
                            }
                          />
                        ))} */}
                        <OtpInput
                          onChange={handleInputChange}
                          value={otpDigits}
                          inputStyle="otp__digit shadow"
                          numInputs={6}
                          separator={<span></span>}
                          renderInput={renderInput}
                          inputComponent={(props, index) => (
                            <input
                              {...props}
                              type="number" // Use type="tel" to display numeric keyboard on mobile devices
                              maxLength={1} // Allow only one character per input box
                              onKeyDown={handleKeyDown}
                              onKeyPress={(e) => {
                                // Prevent default behavior for non-numeric key presses
                                if (e.which < 48 || e.which > 57) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="btn btn-primary w-100 py-2
                       center-textbtn mt-3 text-white text-uppercase"
                        id="submitBtn"
                      >
                        {t("loginBtn")}
                      </button>
                      <button
                        type="button"
                        className={`btn btn-primary w-100 py-2 center-textbtn mt-3 text-white text-uppercase ${!disableBtn ? "disabled" : ""
                          }`}
                        id="submitBtn"
                        onClick={handleResendOtp}
                        disabled={!disableBtn}
                      >
                        {t("resendOtp")}
                      </button>
                    </div>
                  </form>

                  {errroMsg && (
                    <>
                      <div
                        className="alert alert-warning alert-dismissible fade show mt-2"
                        role="alert"
                      >
                        {errroMsg}
                        <button
                          type="button"
                          className="close"
                          onClick={hide}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </>
                  )}
                </div>
                {/* <Spinner/> */}
              </div>
            </div>
          </div>
        </div>

        {/* 
///

MODALS
 */}

        {/* ///genuinity modal component */}

        <CustomModal
          id={"genuinityCheckModal"}
          title={t("genuityCheck")}
          content={
            <>
              {!scanedDataObject.hasOwnProperty('isSpinDone') && (
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={handleNavigation}
                >
                  <img src={Close} alt="Close" />
                </button>
              )}
              {/* <p className="mb-1 modalInfo">{t("serialNO")}: {scanResponseData.prodSerialNumber}</p> */}
              <p className="mb-1 modalInfo">
                {t("productName")}: {scanResponseData?.productName}
              </p>
              <img src={GenuityCheck} alt="GenuityCheck" />
              <div>
                <img src={Right} alt="Right" />
              </div>
              <p className="mb-0 modalInfo">{scanResponseData?.uq_message}</p>
              {scanResponseData.isSpinDone && (
                <p className="mb-0 modalInfo text-danger pt-2">
                  {scanResponseData?.primaryRewardMsg}
                </p>
              )}
            </>
          }
          footer={
            <>
              {scanResponseData &&
                scanResponseData.hasOwnProperty("isSpinDone") &&
                !scanResponseData.isSpinDone && (
                  <Button
                    className="w-100 rounded-4 py-2"
                    onClick={openSpinWheel}
                  >
                    {t("spinToWin")}
                  </Button>
                )}
              {/* <Button
                onClick={() => navigate("/scanProduct")}
                variant="primary"
                className={`${
                  scanResponseData && scanResponseData.hasOwnProperty('isSpinDone') && !scanResponseData.isSpinDone  ? "w-48" : "w-100"
                } rounded-4 py-2`}
              >
                {t("scanProduct")}
              </Button> */}
            </>
          }
          show={modalShow}
          onHide={() => setModalShow(false)}
        />

        {/* spin modal */}
        <CustomModal
          id={"spinModal"}
          title={""}
          content={
            <>
              <div>
                {/* <img src={SpinImage} alt="Right" className="spinImgae spinwheelImg" /> */}
                <CustomRoulette 
                  retailerMblNbr={retailerMblNbr}
                  wheelItems={scanResponseData.wheelItems}
                  stopPrizeNumber={stopPrizeNumber}
                  closeModal={handleCloseModal}
                />
              </div>
            </>
          }
          footer={
            <>
              {showRetailerInput && (
                <input type="text"
                  className={`form-control shadow mb-1 ${mobileNumberError ? "is-invalid" : ""
                    }`}
                  placeholder={t("mblnumberPlaceHolder")}
                  name="retailerMblNbr"
                  id="retailerMblNbr"
                  maxLength="10"
                  autoComplete="off"
                  onInput={handleMblInput}
                />
              )}

              {showCropInput && (
                <select className="form-control cropList" id="crop" name="crop" data-toggle="tooltip"
                  data-placement="top" title="Tooltip on top" onChange={cropChange}>
                  <option value="" selected disabled>Select Crop</option>
                  {cropList.map(crop => (
                    <option key={crop.id} value={crop.id}>{crop.name}</option>
                  ))}
                </select>
              )}

              {mobileNumberError && <div className="invalid-feedback">{mobileNumberError}</div>}

              <Button onClick={handleSpin} className="w-100 rounded-4 py-2">
                {t("SpinWheel")}
              </Button>
            </>
          }
          show={spinModalShow}
          onHide={() => setSpinModalShow(false)}
        />

        {/* 
        /// */}
        <CustomModal
          id={"rewardUpdateModal"}
          title={""}
          content={
            <>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={handleNavigation}
              >
                <img src={Close} alt="Close" />
              </button>

              <img src={SuccessIcon} alt="SuccessIcon" className="succesIcon" />
              <img src={Bottle} alt="Bottle" />
              <p className="congratulationsText"> {t("congratulations")} !!!</p>
              <p className="rewardText">{genunityData.primaryRewardMsg}</p>
            </>
          }
          show={rewardUpdateModal}
          onHide={() => {
            setRewardUpdateModal(false); // Close the modal
            handleNavigation();
          }}
        />

        {/* 
          ///not genuine case */}

        <CustomModal
          id={"genuinityCheckModalError"}
          title={t("genuityCheck")}
          content={
            <>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={() => {
                  setErrorModalGenunity(false);
                  handleNavigation();
                }}
              >
                <img src={Close} alt="Close" />
              </button>
              {/* <p className="mb-1 modalInfo">{t("serialNO")}: {scanResponseData.prodSerialNumber}</p> */}
              {scanErrorResponseData?.productName && (
                <p className="mb-1 modalInfo">
                  {t("productName")}: {scanErrorResponseData.productName}
                </p>
              )}

              <img src={GenuityCheck} alt="GenuityCheck" />
              <div>
                <img
                  src={notGeniuneImg}
                  alt="Right"
                  style={{ width: "50px" }}
                />
              </div>
              <p className="mb-0 modalInfo">
                {scanErrorResponseData?.uq_message}
              </p>
              {scanErrorResponseData.isSpinDone && (
                <p className="mb-0 modalInfo text-danger pt-2">
                  {scanErrorResponseData?.primaryRewardMsg}
                </p>
              )}
            </>
          }
          footer={<></>}
          show={ErrorModalGenunity}
          onHide={() => setErrorModalGenunity(false)}
        />
      </Layout>
    </>
  );
};
